type ParallelogramIconProps = {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
};

export const ParallelogramIcon = (props: ParallelogramIconProps) => (
  <svg
    width="35"
    height="24"
    viewBox="0 0 35 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7282 3.06354e-07L34.8103 0L16.4161 24L-7.04252e-06 24L18.7282 3.06354e-07Z"
      fill="currentColor"
    />
  </svg>
);
